import * as App from '../../app';
import * as SDK from '../../lib/sdk';
import { StyleSheet } from './../../lib/classes';
export function rootEl() {
    var rootEl = document.getElementById('root');
    var _a = App.themes.get(), name = _a.name, bg = _a.bg;
    rootEl.classList.add('loading');
    rootEl.classList.add("".concat(name, "-theme"));
    new StyleSheet("#root.loading { background-color: ".concat(bg, " }"));
    SDK.getLangSafe().then(function (lang) {
        rootEl.classList.add(lang);
        App.emitter.on('lang', function (lang) {
            rootEl.classList.toggle('ru', lang === 'ru');
            rootEl.classList.toggle('en', lang !== 'ru');
        });
    });
    if (IS_ULTRA) {
        rootEl.classList.add('ultra-theme');
    }
    return rootEl;
}
